import React, { useState } from "react";
import Swal from "sweetalert2";
import styled from "styled-components";

const BulletinForm = ({ onSave }) => {
    const [newBulletin, setNewBulletin] = useState(""); // Initialize new bulletin content as an empty string

    // Handle the save action for the new bulletin
    const handleSave = () => {
        if (!newBulletin.trim()) { // Check if bulletin content is empty
            Swal.fire({
                icon: 'warning',
                title: 'Bulletin content cannot be empty',
                confirmButtonColor: '#3085d6',
            });
            return;
        }
        onSave(newBulletin); // Save the bulletin content
        setNewBulletin(""); // Reset the input field
    };

    return (
        <div className="container mb-4">
            <TextArea
                value={newBulletin}
                onChange={(e) => setNewBulletin(e.target.value)}
                placeholder="Enter new bulletin content"
                rows="3"
            />
            <ButtonContainer>
                <PublishButton onClick={handleSave}>
                    Publish Bulletin
                </PublishButton>
            </ButtonContainer>
        </div>
    );
};

export default BulletinForm;

// Styled Components
const TextArea = styled.textarea`
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border: 1px solid var(--app-border, #ddd);
    border-radius: 5px;
    resize: none;
    outline: none;
    background: var(--app-input-bg, #fff);
    color: var(--app-input-text, #202124);
    transition: border-color 0.3s;

    &::placeholder {
        color: var(--app-muted-text, #8b929e);
        opacity: 1;
    }

    &:focus {
        border-color: #3085d6;
    }

    @media (min-width: 768px) {
        font-size: 1.1rem; // Increase font size slightly on medium screens
    }
`;

// Flex container for centering the button
const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10px;
`;

const PublishButton = styled.button`
    padding: 10px 20px;
    font-size: 1rem;
    color: #fff;
    background-color: #3085d6;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #2672b8;
    }

    @media (min-width: 768px) {
        padding: 12px 24px; // Increase padding for larger screens
        font-size: 1.1rem; // Increase font size slightly
    }
`;

